import { Card } from "../../../components/Card";
import { Badge, Box, Divider, Flex, Heading, useBreakpointValue } from "@chakra-ui/react";
import { CustomHeatmap } from "./index";

function HeatmapCard({ title, containerId, data, headers, colors, tooltipAttributes, clickHandling }) {
  const headerDisplayType = useBreakpointValue({ base: "block", xl: "flex" });

  return (
    <Card boxShadow="xs" overflow="auto">
      <Flex justifyContent="space-between" alignItems="baseline" display={headerDisplayType}>
        <Heading as="h2" size="md">
          {title}
        </Heading>
        <Box>
          {colors.map((colorItem, index) => {
            return <Badge
              key={`${containerId}-legend-item-${colorItem.value}`}
              backgroundColor={colorItem.color}
              color={colorItem.legendTextColor}
              marginRight={index < colors.length - 1 ? 2 : 0}
            >
              {colorItem.legendText}
            </Badge>;
          })}
        </Box>
      </Flex>
      <Divider marginBlock={5} />
      <CustomHeatmap
        containerId={containerId}
        data={data}
        headers={headers}
        colors={colors}
        tooltipAttributes={tooltipAttributes}
        clickHandling={clickHandling}
      />
    </Card>
  );
}

export default HeatmapCard;